import { Injectable, isDevMode } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { DealerProfileService } from './dealer-profile.service';
import { Observable } from 'rxjs';
import { DealerProfile } from '@app/domain/model/dealer-profile';
import { catchError, take } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import * as HttpStatus from 'http-status-codes';
import { AuthenticationService } from '@app/shared/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class DealerProfileResolver implements Resolve<DealerProfile> {

  constructor(private reader: DealerProfileService,
              private router: Router,
              private authenticator: AuthenticationService) {
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Observable<DealerProfile> | Promise<DealerProfile> | DealerProfile {

    return this.reader
      .getDealerProfile(route.params.dealerId)
      .pipe(
        take(1),
        catchError(error => {
          if (isDevMode()) {
            console.error('Dealer Profile error: ', error);
          }
          if ((error instanceof HttpErrorResponse) && (error.status === HttpStatus.UNAUTHORIZED)) {
            if(this.authenticator.isLoggedIn()){
              this.authenticator.clearSession();
            }

            const returnURL = this.router.routerState.snapshot.url;
            this.router.navigate(['/login'], {queryParams: {returnUrl: returnURL}});
            return Promise.resolve(null);
          } else {
            return Promise.reject(error.message || error);
          }
        }));
  }

}
